module.exports = __webpack_public_path__ + "static/media/content-step3.959de2ba.jpg";